import React from "react";
import { VegaChip } from "@heartlandone/vega-react";
import { ACTIVITY_STATUS } from "Chore/Constants";

const { STATUS_LABEL } = ACTIVITY_STATUS;

const ActivityState = ({ state }) => {
  const _getBgColorByStatus = (status) => {
    switch (status) {
      case STATUS_LABEL.CLOSED:
        return "bg-status-error";
      case STATUS_LABEL.OPEN:
        return "bg-status-success";
      case STATUS_LABEL.NEW:
        return "bg-accent1-primary";
      default:
        return "bg-status-error";
    }
  };

  const _getTextColorByStatus = (status) => {
    switch (status) {
      case STATUS_LABEL.CLOSED:
        return;
      case STATUS_LABEL.OPEN:
        return "text-success";
      case STATUS_LABEL.NEW:
        return "text-primary";
      default:
        return "text-danger-link-visited";
    }
  };
  return (
    <VegaChip
      text={state}
      size="small"
      bgColor={_getBgColorByStatus(state)}
      textColor={_getTextColorByStatus(state)}
      style={state === STATUS_LABEL.CLOSED ? { color: "#6D0612" } : {}}
    ></VegaChip>
  );
};

export default ActivityState;
